/* eslint-disable linebreak-style */
import {createSelector} from 'reselect';
import { getCurrentLocale } from '../../i18n';
import { getLookupWarning } from '../../utils/lookupLocale';

const selectLookup=state=>state.lookup;
const selectLocale=()=>getCurrentLocale();

const localizeLookupWarnings = (node, locale)=>{
  if (Array.isArray(node)) {
    return node.map(item=>localizeLookupWarnings(item, locale));
  }
  if (!node || typeof node !== 'object') {
    return node;
  }
  const localizedNode = {};
  Object.keys(node).forEach(key=>{
    localizedNode[key] = localizeLookupWarnings(node[key], locale);
  });
  // Keep warning value locale-aware even if component instances stay mounted.
  Object.defineProperty(localizedNode, 'atentionare', {
    enumerable: true,
    configurable: true,
    get: ()=> getLookupWarning(node)
  });
  return localizedNode;
};

const createLocalizedLookupSelector = (lookupKey)=> createSelector(
  [selectLookup, selectLocale],
  (lookup, locale)=> localizeLookupWarnings(lookup[lookupKey], locale)
);

export const selectLookupProduse= createSelector(
  [createLocalizedLookupSelector('produse')],
  produse=>produse
);

export const selectLookupMateriale= createSelector(
  [createLocalizedLookupSelector('materiale')],
  materiale=>materiale
);

export const selectLookupPreturiTabelare= createSelector(
  [createLocalizedLookupSelector('preturitabelare')],
  preturitabelare=>preturitabelare
);

export const selectLookupOptionale= createSelector(
  [createLocalizedLookupSelector('optionale')],
  optionale=>optionale
);

export const selectLookupCulori= createSelector(
  [createLocalizedLookupSelector('culori')],
  culori=>culori
);

export const selectLookupInformari= createSelector(
  [createLocalizedLookupSelector('informari')],
  informari=>informari
);

export const selectLookupIndicatori= createSelector(
  [createLocalizedLookupSelector('indicatori')],
  indicatori=>indicatori
);

export const selectLookupFirma= createSelector(
  [createLocalizedLookupSelector('firma')],
  firma=>firma
);

export const selectLookupFirmeComisionar= createSelector(
  [createLocalizedLookupSelector('firmeComisionar')],
  firmeComisionar=>firmeComisionar
);

export const selectLookupCurs= createSelector(
  [selectLookup],
  lookup=>lookup.curs
);